export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";